<div [ngClass]="'alert-header'">
    <span [ngClass]="'alert-title'"> {{data.alertTitle}} </span>
    <span> <img [ngClass]="'clickable'" (click)="closeWindow()" src="assets/icon/Close-Icon.svg"> </span>
</div>
<div [ngClass]="'alert-body'"> 
    <div> {{data.alertText}} </div>
    <div [ngClass]="'button-row'"> <submit-button [buttonTitle]="'OK'" (click)="closeWindow()" ></submit-button> </div>
</div>